export default "__VITE_ASSET__7cfce5b8__"